import {mapOverlayPanes} from "base/component/geo";
import {createLayerLegend, useLayerObject} from "base/map";

const MENU_ICON_SHAPE = "s"; // "s", "l","H""

const markerBaseOptions = {
    marker: MENU_ICON_SHAPE,
    fillColor: "#466269",
    radius: 10,
    color: "#466269",
    addStroke: true,
    weight: 1,
    opacity: 1,
    fillOpacity: 1,
    lineJoin: "round",
    pane: mapOverlayPanes[8],
    interactive: false,
};

// const mspeezfitnessFieldConfig = [
//     {key: "id", label: "ID"},
//     {key: "country", label: "Country"},
// ];

// const createMspeezfitnessTooltip = data => {
//     return generateTooltipHTML("MSP-EEZ fitness", data, mspeezfitnessFieldConfig, {
//         width: "400px",
//         height: "200px",
//         wrapValues: true,
//     });
// };

export const LayerLegend = createLayerLegend({
    layerName: "MSP-EEZ fitness",
    menuIconShape: MENU_ICON_SHAPE,
    defaultMarkerOptions: markerBaseOptions,
});

export function useMspeezfitnessLayer(onSelectElement) {
    return useLayerObject({
        legend: LayerLegend,
        // metadata: "MARPLAN_Datos_Batimetria_01122023_MD.XML",
        detail: false,
        // getTooltip: ({feature}) => {
        //     let data = feature.properties;
        //     return createMspeezfitnessTooltip(data);
        // },
        // // TODO next methods are necessary for map inside EntityListMap
        // // We have to design this component without repeating if is from EntityListMap or MapProvider
        // getCustomMarkerOptions: () => markerBaseOptions,
        // defaultOnClick: ({feature}) => onSelectElement(feature.id),
    });
}
